import { render, staticRenderFns } from "./_layout.vue?vue&type=template&id=5742c38e&scoped=true&"
import script from "./_layout.vue?vue&type=script&lang=js&"
export * from "./_layout.vue?vue&type=script&lang=js&"
import style0 from "./_layout.vue?vue&type=style&index=0&id=5742c38e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5742c38e",
  null
  
)

export default component.exports